
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.284 7.791a.989.989 0 000-1.404.999.999 0 00-1.41 0l-1.48 1.474a8.237 8.237 0 00-5.1-1.762c-4.568 0-8.288 3.703-8.288 8.253 0 1.911.67 3.674 1.77 5.077l-1.48 1.474a.988.988 0 00.71 1.692c.26 0 .51-.1.71-.288l1.48-1.474a8.237 8.237 0 005.099 1.762c4.57 0 8.289-3.703 8.289-8.253 0-1.912-.67-3.674-1.77-5.078l1.47-1.473zm-14.278 6.55c0-3.454 2.82-6.261 6.289-6.261 1.37 0 2.64.448 3.68 1.194l-8.76 8.722a6.12 6.12 0 01-1.21-3.654zm12.568 0c0 3.456-2.82 6.263-6.29 6.263a6.24 6.24 0 01-3.668-1.195l8.758-8.72a6.178 6.178 0 011.2 3.653z"}})])
          )
        }
      }
    